export default "__VITE_ASSET__84041063__"